import { ECarrier } from "../Model/ECarrier";
import {
  Ri360HotelCalibration,
  Ri360CarrierCalibration,
  Ri1000CarrierCalibration,
  Ri1000HotelCalibration,
  CarrierCalibration,
  HotelCalibration,
} from "../Model/StorageConfig";
import {
  CartesianWaypoint,
  EArmType,
  EAxisType,
  ModuleWaypoint,
  Waypoint,
  toWaypoint,
} from "../Model/Waypoint";

class WaypointUtil {
  static getWaypoints(
    moduleWaypoints: ModuleWaypoint[],
    moduleIdentifier: string,
    armType: EArmType,
    carrier: ECarrier
  ) {
    let waypoints: Waypoint[] = [];

    moduleWaypoints.forEach((moduleWaypoint) => {
      if (moduleWaypoint.moduleIdentifier === moduleIdentifier) {
        moduleWaypoint.cartesianWaypoints?.forEach((waypoint) => {
          if (waypoint.armType == armType && waypoint.carrier == carrier) {
            waypoints.push(toWaypoint(waypoint));
          }
        });
      }

      moduleWaypoint.cylindricalWaypoints?.forEach((waypoint) => {
        if (waypoint.armType == armType && waypoint.carrier == carrier) {
          waypoints.push(toWaypoint(waypoint));
        }
      });
    });
    return waypoints;
  }

  static GetWaypointNameByArmType(waypointMap: ModuleWaypoint) {
    let result: { [index: number]: string[] } = {};
    if (waypointMap.cartesianWaypoints) {
      for (let i = 0; i < waypointMap.cartesianWaypoints.length; i++) {
        const waypoint = waypointMap.cartesianWaypoints[i];
        if (!result[waypoint.armType]) {
          result[waypoint.armType] = [];
        }
        result[waypoint.armType].push(waypoint.name);
      }
    }
    if (waypointMap.cylindricalWaypoints) {
      for (let i = 0; i < waypointMap.cylindricalWaypoints.length; i++) {
        const waypoint = waypointMap.cylindricalWaypoints[i];
        if (!result[waypoint.armType]) {
          result[waypoint.armType] = [];
        }
        result[waypoint.armType].push(waypoint.name);
      }
    }

    return result;
  }

  static onlyUnique<T>(value: T, index: number, self: T[]) {
    return self.indexOf(value) === index;
  }

  // usage example:
  //var a = ['a', 1, 'a', 2, '1'];
  //var unique = a.filter(onlyUnique);

  static getModuleIdentifiers(moduleWaypoints: ModuleWaypoint[]) {
    let moduleIdentifiers: string[] = [];

    moduleWaypoints.forEach((element) => {
      moduleIdentifiers.push(element.moduleIdentifier);
    });

    return moduleIdentifiers;
  }

  static getArmTypes(
    moduleWaypoints: ModuleWaypoint[],
    moduleIdentifier: string
  ) {
    let armTypes: EArmType[] = [];

    moduleWaypoints.forEach((moduleWaypoint) => {
      if (moduleWaypoint.moduleIdentifier === moduleIdentifier) {
        moduleWaypoint.cartesianWaypoints?.forEach((waypoint) => {
          armTypes.push(waypoint.armType);
        });

        moduleWaypoint.cylindricalWaypoints?.forEach((waypoint) => {
          armTypes.push(waypoint.armType);
        });
      }
    });

    return armTypes.filter(WaypointUtil.onlyUnique);
  }

  static getHotels(
    storageCalibrations: CarrierCalibration[],
    carrier: ECarrier
  ) {
    let hotels: HotelCalibration[] = [];

    storageCalibrations.forEach((storageCalibration) => {
      if (storageCalibration.carrier == carrier) {
        hotels.push(...storageCalibration.hotelCalibrations);
      }
    });

    return hotels;
  }

  static getRi360Hotels(
    storageCalibrations: Ri360CarrierCalibration[],
    carrier: ECarrier
  ) {
    let hotels: Ri360HotelCalibration[] = [];

    storageCalibrations.forEach((storageCalibration) => {
      if (storageCalibration.carrier == carrier) {
        hotels.push(...storageCalibration.hotelCalibrations);
      }
    });

    return hotels;
  }

  static getCarriers(
    moduleWaypoints: ModuleWaypoint[],
    moduleIdentifier: string,
    armType: EArmType
  ): ECarrier[] {
    let carriers: ECarrier[] = [];

    moduleWaypoints.forEach((moduleWaypoint) => {
      if (moduleWaypoint.moduleIdentifier === moduleIdentifier) {
        moduleWaypoint.cartesianWaypoints?.forEach((waypoint) => {
          if (waypoint.armType == armType) {
            carriers.push(waypoint.carrier);
          }
        });

        moduleWaypoint.cylindricalWaypoints?.forEach((waypoint) => {
          if (waypoint.armType == armType) {
            carriers.push(waypoint.carrier);
          }
        });
      }
    });

    return carriers.filter(WaypointUtil.onlyUnique);
  }

  static getAllWaypointNames(
    moduleWaypoints: ModuleWaypoint[],
    carrier?: ECarrier
  ) {
    let waypointNames: string[] = [];

    moduleWaypoints.forEach((moduleWaypoint) => {
      moduleWaypoint.cartesianWaypoints?.forEach((waypoint) => {
        if (carrier != null) {
          if (carrier == waypoint.carrier) {
            waypointNames.push(waypoint.name);
          }
        } else {
          waypointNames.push(waypoint.name);
        }
      });

      moduleWaypoint.cylindricalWaypoints?.forEach((waypoint) => {
        if (carrier != null) {
          if (carrier == waypoint.carrier) {
            waypointNames.push(waypoint.name);
          }
        } else {
          waypointNames.push(waypoint.name);
        }
      });
    });

    return waypointNames;
  }

  static getWaypointNames(
    moduleWaypoints: ModuleWaypoint[],
    moduleIdentifier: string,
    armType: EArmType
  ) {
    let waypointNames: string[] = [];

    moduleWaypoints.forEach((moduleWaypoint) => {
      if (moduleWaypoint.moduleIdentifier === moduleIdentifier) {
        moduleWaypoint.cartesianWaypoints?.forEach((waypoint) => {
          if (waypoint.armType === armType) {
            waypointNames.push(waypoint.name);
          }
        });

        moduleWaypoint.cylindricalWaypoints?.forEach((waypoint) => {
          if (waypoint.armType === armType) {
            waypointNames.push(waypoint.name);
          }
        });
      }
    });

    return waypointNames;
  }
}

export default WaypointUtil;
